import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react'

interface EmptyStateProps {
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <Box textAlign="center" py={12}>
      <VStack gap={4}>
        <Heading size="md" color="gray.600">
          {title}
        </Heading>

        {description && (
          <Text color="gray.500" maxW="md">
            {description}
          </Text>
        )}

        {action && (
          <Button colorPalette="brand" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </VStack>
    </Box>
  )
}
